export default __webpack_public_path__ + "static/media/bus.3684d494.svg";